export default "__VITE_ASSET__0RzuyGpW__"